import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const PageOptionView = Backbone.View.extend({
    tagName: 'option',
    initialize() {
        this.template = _.template(TextTemplate)
    },
    render() {
        this.$el.val(this.model.get('number'))
        if (this.model.get('selected')) {
            this.$el.attr('selected', 'selected')
        }
        this.$el.html(this.template({text: this.model.get('number')}))
        return this
    }
})

export default PageOptionView
